import React, { useEffect } from 'react';
import { Box, CustomModalLayout, Loader } from '@wix/design-system';
import { reportModalShown } from '../../bi/bi';
import { Modals } from '../../types';
import { useInstallerContext } from '../../context/InstallerContext';

// this modal DOES NOT support translations
export const LoadingModal = () => {
  const {
    tenantId
  } = useInstallerContext();
  useEffect(() => {
    reportModalShown(Modals.loading);
  }, []);
  return tenantId ? /*#__PURE__*/React.createElement(CustomModalLayout, {
    width: "600px",
    height: "700px"
  }, /*#__PURE__*/React.createElement(Box, {
    height: "100%",
    align: "center",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(Loader, {
    size: "medium"
  }))) : /*#__PURE__*/React.createElement(Loader, null);
};
//# sourceMappingURL=LoadingModal.js.map